module.exports = __webpack_public_path__ + "img/app_store1.9de0f01c.png";